import { render, staticRenderFns } from "./SchoolAccountTerms.vue?vue&type=template&id=4de65eeb"
import script from "./SchoolAccountTerms.vue?vue&type=script&lang=ts"
export * from "./SchoolAccountTerms.vue?vue&type=script&lang=ts"
import style0 from "./SchoolAccountTerms.vue?vue&type=style&index=0&id=4de65eeb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports